import { load } from 'recaptcha-v3'

export default {
    data() {
        return {
            showManualAddress: false,
            inputsTouched: {
                zipcode: false,
                address2: false
            },
            lastSearched: {
                zipcode: null,
                address2: null
            }
        }
    },

    methods: {
        resetAddressFields() {
            this.customer.address = ''
            this.customer.city = ''
            // Don't reset showManualAddress here since it should persist
        },

        resetInputTouched() {
            this.inputsTouched.zipcode = false
            this.inputsTouched.address2 = false
            this.lastSearched.zipcode = null
            this.lastSearched.address2 = null
        },

        async searchAddress(type = 'default', siteKey = null) {
            if (!this.customer.zipcode || !this.customer.address2) {
                this.$buefy.toast.open({
                    message: 'Vul eerst een postcode en huisnummer in.',
                    type: 'is-warning'
                })
                return
            }

            this.saving = true
            const zipcode = this.customer.zipcode.replace(/\s+/g, '')
            const number = this.customer.address2

            try {
                let url = `/api/address-lookup?zipcode=${zipcode}&number=${number}`
                let headers = type === 'online-rental' ? {} : {'Authorization': 'bearer ' + this.$store.state.authToken}

                // For online rental, use different endpoint and add reCAPTCHA
                if (type === 'online-rental') {
                    if (!siteKey) {
                        throw new Error('reCAPTCHA site key is required for online rental')
                    }
                    const recaptcha = await load(siteKey)
                    const token = await recaptcha.execute('address_lookup')
                    url = `/online-huren/address-lookup?zipcode=${zipcode}&number=${number}&token=${token}`
                    headers = {} // No auth token needed for public endpoint
                }

                // Store the current search values
                this.lastSearched.zipcode = zipcode
                this.lastSearched.address2 = number

                const response = await axios({
                    method: 'get',
                    url: url,
                    headers: headers
                })

                if (response.data && response.data.street && response.data.city) {
                    this.customer.address = response.data.street
                    this.customer.city = response.data.city
                    this.$buefy.toast.open({
                        message: 'Adres gevonden!',
                        type: 'is-success'
                    })
                } else {
                    this.$buefy.toast.open({
                        message: 'Geen adres gevonden voor deze postcode en huisnummer.',
                        type: 'is-warning'
                    })
                    this.showManualAddress = true
                }
            } catch (error) {
                console.error('[❌] Error while looking up address', error)
                let message = 'Er is een fout opgetreden bij het zoeken van het adres'

                if (error.response) {
                    if (error.response.status === 400) {
                        message = 'Ongeldige postcode of huisnummer.'
                    } else if (error.response.status === 404) {
                        message = 'Geen adres gevonden voor deze postcode en huisnummer.'
                    } else if (error.response.status === 403) {
                        message = 'Verificatie mislukt. Probeer het opnieuw.'
                    } else if (error.response.status === 429) {
                        message = 'Te veel aanvragen. Probeer het later opnieuw.'
                    } else if (error.response.status === 500) {
                        message = type === 'online-rental' ? 'Er is een fout opgetreden. Probeer het later opnieuw.' : 'Postcode API configuratie fout.'
                    }
                }

                this.$buefy.toast.open({
                    message: message,
                    type: 'is-danger',
                    duration: 5000
                })
                this.showManualAddress = true
            } finally {
                this.saving = false
            }
        }
    },

    watch: {
        'customer.zipcode': function(newVal, oldVal) {
            if (!newVal || newVal.trim() === '') {
                this.resetAddressFields()
            }
            // Only mark as touched if value actually changed
            if (newVal !== oldVal) {
                this.inputsTouched.zipcode = true
                // Reset last searched when zipcode changes
                this.lastSearched.zipcode = null
            }
        },
        'customer.address2': function(newVal, oldVal) {
            if (!newVal || newVal.trim() === '') {
                this.resetAddressFields()
            }
            // Only mark as touched if value actually changed
            if (newVal !== oldVal) {
                this.inputsTouched.address2 = true
                // Reset last searched when number changes
                this.lastSearched.address2 = null
            }
        },
        'customer.country': function(newVal) {
            if (newVal !== 'Nederland') {
                // For non-Netherlands addresses, show manual entry immediately
                this.showManualAddress = true
            } else {
                // For Netherlands, only reset if we don't have an address
                if (!this.customer.address) {
                    this.resetAddressFields()
                }
            }
        }
    }
}